import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import { IDongBoHocPhiActionTypes } from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { IdongBoHocPhiReducer } from "../../reducer-model/dong-bo/IDongBoHocPhiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IdongBoHocPhiReducer = {
  sinhViens: [],
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  displayMode: getDefaultDisplayMode(),
  idSvViewLopTinChi: "",
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_svs: [],
  } as IDongBoHocPhiRequest,
  hoanVeVi: {
    isShow: false,
    status: eReducerStatusBase.is_not_initialization,
    khoans: [],
    idSelections: [],
  },
} as IdongBoHocPhiReducer;

export const dongBoHocPhiReducer = (
  state: IdongBoHocPhiReducer = iniState,
  action: IDongBoHocPhiActionTypes,
): IdongBoHocPhiReducer => {
  switch (action.type) {
    case "DONG_BO_HOC_PHI_LOAD_START":
      return {
        ...state,
        sinhViens: [] as IDongBoHocPhiSinhVien[],
        status: eReducerStatusBase.is_loading,
      };
    case "DONG_BO_HOC_PHI_LOAD_SUCCESS":
      return {
        ...state,
        sinhViens: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_HOC_PHI_LOAD_ERRR":
      return {
        ...state,
        sinhViens: [] as IDongBoHocPhiSinhVien[],
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_HOC_PHI_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DONG_BO_HOC_PHI_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        focusedCell: undefined,
        idSelections: [],
      };
    case "DONG_BO_HOC_PHI_SHOW_HIDE_VIEW_LOP_TIN_CHI":
      return {
        ...state,
        idSvViewLopTinChi: action.payload,
      };
    case "DONG_BO_HOC_PHI_SYNC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DONG_BO_HOC_PHI_SYNC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        idSelections: [],
      };
    case "DONG_BO_HOC_PHI_SYNC_ERR":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_HOC_PHI_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };

    case "DONG_BO_HOC_PHI_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_HOC_PHI_CHANGE_SINHVIEN_SELECTED_IDS":
      return {
        ...state,
        idSelections: action.payload,
      };

    // ===== Hoàn về ví hàng loạt =====
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_SHOW_MODAL":
      return {
        ...state,
        hoanVeVi: action.payload
          ? { ...state.hoanVeVi, isShow: true }
          : {
              ...state.hoanVeVi,
              isShow: false,
              khoans: [],
              idSelections: [],
              request: undefined,
              status: eReducerStatusBase.is_not_initialization,
            },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_LOAD_START":
      return {
        ...state,
        hoanVeVi: {
          ...state.hoanVeVi,
          request: action.payload,
          khoans: [],
          idSelections: [],
          status: eReducerStatusBase.is_loading,
        },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_LOAD_SUCCESS":
      return {
        ...state,
        hoanVeVi: {
          ...state.hoanVeVi,
          khoans: action.payload,
          status: eReducerStatusBase.is_completed,
        },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_LOAD_ERR":
      return {
        ...state,
        hoanVeVi: {
          ...state.hoanVeVi,
          khoans: [],
          status: eReducerStatusBase.is_completed,
        },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        hoanVeVi: { ...state.hoanVeVi, idSelections: action.payload },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_START":
      return {
        ...state,
        hoanVeVi: {
          ...state.hoanVeVi,
          status: eReducerStatusBase.is_saving,
          processId: action.payload.process_id,
          isShowProcessing: true,
        },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_SUCCESS":
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_ERR":
      // Nạp lại cả danh sách hoàn về ví lẫn danh sách đồng bộ (sinh viên vừa hoàn đang giữ tiền
      // nên không còn hiện là "cần đồng bộ" chỉ vì khoản thiếu).
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        hoanVeVi: {
          ...state.hoanVeVi,
          idSelections: [],
          status: eReducerStatusBase.is_need_reload,
        },
      };
    case "DONG_BO_HOC_PHI_HOAN_VE_VI_CLOSE_PROCESSING":
      return {
        ...state,
        hoanVeVi: { ...state.hoanVeVi, isShowProcessing: false },
      };

    default:
      return state;
  }
};
